export function convertSpacesToNonBreakingSpaces(s: string) {
  return s.split(" ").join("\u00A0");
}

export function stripHTML(htmlStr: string): string {
  // This should be safe to use because DOMParser does not execute script nodes
  // https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
  //     "Note that script elements are not evaluated during parsing, and the resulting
  //      document's encoding will always be UTF-8."
  const doc = new DOMParser().parseFromString(htmlStr, "text/html");
  return doc.body.textContent || "";
}

// From fraction
export function capitalize(str: string): string {
  // TODO: Edge cases related to extra spaces
  return str.toLowerCase().replace(/(\s|^)./g, function (a) {
    return a.toUpperCase();
  });
}

// from fraction
/* prettier-ignore */
// prettier seems to be stripping \s from my strings
// TODO https://tickets.ingramcontent.com/browse/BO-3474
// vst-models: /\A([^@\s]+)@((?:[-_a-z0-9]+\.)+[a-z]{2,})\Z/i;
// old-reg: /^([^@\s]+)@((?:[-_a-z0-9]+\.)+[a-z]{2,})$/
export const EMAIL_PATTERN = "^([^@\\s]+)@((?:[-_a-z0-9]+\\.)+[a-z]{2,})$";

// http://erlycoder.com/49/javascript-hash-functions-to-convert-string-into-integer-hash-
export function hash(s) {
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    /* eslint-disable no-bitwise */
    hash = s.charCodeAt(i) + (hash << 6) + (hash << 16) - hash;
    /* eslint-enable no-bitwise */
  }
  return hash;
}

// From fraction
// http://stackoverflow.com/questions/3700326/decode-amp-back-to-in-javascript
export function decodeHTML(s: string) {
  const elem = document.createElement("textarea");
  elem.innerHTML = s;
  return elem.value;
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
export const escapeRegExp = (str: string): string => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
};
